import React from "react";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="container">
        <a href="/" className="navbar-brand">
          PokeAPI
        </a>
      </div>
    </nav>
  );
}

export default Navbar;
